import type {ContextProviderDataGeneric} from '@bitstillery/common/lib/context'
import {MithrilComponent} from '@bitstillery/mithril'
import {Button} from '@bitstillery/common/components'
import {classes, present} from '@bitstillery/common/lib/utils'
import m from '@bitstillery/mithril'
import {$t} from '@bitstillery/common/app'

import type {ContextProvider} from '@bitstillery/common/lib/context'
import type {CollectionProxy} from '@bitstillery/common/lib/collection'

interface CollectionBulkControlAttrs {
    action?: string
    className?: string
    context?: ContextProvider<ContextProviderDataGeneric> | undefined
    collection: CollectionProxy
}

export class CollectionBulkControl extends MithrilComponent<CollectionBulkControlAttrs> {
    view(vnode: m.Vnode<CollectionBulkControlAttrs>) {
        if (!vnode.attrs.collection.state.ready) {
            return null
        }

        const bulk = present(vnode.attrs.collection.bulk, 'collection bulk')
        const changed_rows = Object.values(bulk.state.rows).filter((i) => i.changed)
        const {entity_type} = bulk.state
        return (
            <div className={classes('c-collection-bulk', vnode.attrs.className ?? '')}>
                <Button
                    active={vnode.attrs.context?.link_entity_active(entity_type, 'BULK')}
                    disabled={vnode.attrs.collection.state.inline_edit_mode}
                    icon={(() => {
                        if (changed_rows.length > 0) {
                            return 'cancel'
                        }
                        return bulk.icon ? bulk.icon : 'edit'
                    })()}
                    link={vnode.attrs.context?.link_entity(entity_type, 'BULK', undefined, undefined, 'edit')}
                    onclick={() => {
                        if (vnode.attrs.collection.state.bulk_mode) {
                            vnode.attrs.collection.state.selection.ids.splice(
                                0,
                                vnode.attrs.collection.state.selection.ids.length,
                            )
                            vnode.attrs.collection.state.selection.mode = 'select'
                        }
                        vnode.attrs.collection.state.bulk_mode = !vnode.attrs.collection.state.bulk_mode
                        if (!vnode.attrs.collection.state.bulk_mode) {
                            vnode.attrs.collection.state.selection.mode = ''
                        }
                    }}
                    tip={() => {
                        if (vnode.attrs.collection.state.bulk_mode) {
                            if (Object.values(bulk.state.rows).some((i) => i.changed)) {
                                return $t('collection.bulk.tip.cancel_changes')
                            }
                            return $t('collection.bulk.tip.cancel')
                        }
                        return $t('collection.bulk.tip.toggle')
                    }}
                    type={changed_rows.length > 0 ? 'danger' : 'info'}
                    variant='toggle'
                />

                {bulk.actions(changed_rows).map((action) => action)}
            </div>
        )
    }
}
